import { PropsWithChildren, useState } from "react";
import { NavBar } from "./NavBar.tsx";
import { SideMenu } from "./SideMenu.tsx";
import { classNames } from "../Utils/classNames.ts";
import { SignedInUserSection } from "./SignedInUser.tsx";
import { useSideMenuCollapsedPreference } from "./useSideMenuCollapsedPreference.ts";

type Props = PropsWithChildren<{ maxWClass?: string }>;
export function Layout({ children, maxWClass }: Props) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { isSideMenuCollapsed, toggleSideMenuCollapsed } =
    useSideMenuCollapsedPreference();
  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  return (
    <div className={"flex min-h-screen relative"}>
      <div className={"hidden md:block sticky top-0 h-screen"}>
        <SideMenu
          collapsed={isSideMenuCollapsed}
          onToggleCollapsed={toggleSideMenuCollapsed}
        />
      </div>
      {isMobileMenuOpen && (
        <div className={"fixed inset-0 z-50 md:hidden"}>
          <SideMenu
            onNavigate={closeMobileMenu}
            onClose={closeMobileMenu}
            footer={<SignedInUserSection />}
          />
        </div>
      )}
      <div
        className={"flex-1 min-w-0 flex flex-col items-stretch bg-slate-100"}
      >
        <div className={"mb-4"}>
          <NavBar onOpenMobileMenu={() => setIsMobileMenuOpen(true)} />
        </div>
        <div
          className={classNames(
            "p-4 mx-auto flex-1 w-full",
            maxWClass ? maxWClass : "max-w-[1024px]",
          )}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
